import { hasClass } from "element-ui/src/utils/dom";
import { arrayFind } from "element-ui/src/utils/util";
const meadowTextMap = ["early", "middle", "late"];

// 年季旬 displayValue mapping
const valueMapping = {
  quarter: {
    "01": "一",
    "04": "二",
    "07": "三",
    10: "四",
  },
  halfYear: {
    "01": "上",
    "07": "下",
  },
  meadow: {
    "01": "上",
    11: "中",
    21: "下",
  },
};
const timeForYMDDate = function (date) {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  ).getTime();
};
// 季度/半年点击
const handleMonthClick = function (event, interval) {
  let target = event.target;
  if (target.tagName === "A") {
    target = target.parentNode.parentNode;
  }
  if (target.tagName === "DIV") {
    target = target.parentNode;
  }
  if (target.tagName !== "TD") return;
  if (hasClass(target, "disabled")) return;
  const column = target.cellIndex;
  let month = column * interval;
  const newDate = this.getMonthOfCell(column);
  if (this.selectionMode === "range") {
    if (!this.rangeState.selecting) {
      this.$emit("pick", { minDate: newDate, maxDate: null });
      this.rangeState.selecting = true;
    } else {
      if (newDate >= this.minDate) {
        this.$emit("pick", { minDate: this.minDate, maxDate: newDate });
      } else {
        this.$emit("pick", { minDate: newDate, maxDate: this.minDate });
      }
      this.rangeState.selecting = false;
    }
  } else {
    this.$emit("pick", month);
  }
};
const getMonthOfCell = function (month, interval) {
  const year = this.date.getFullYear();
  return new Date(year, month * interval, 1);
};
// interval {10=旬 3=季度 6=半年}
const markRange = function (minDate, maxDate, interval) {
  minDate = timeForYMDDate(new Date(minDate));
  maxDate = maxDate ? timeForYMDDate(new Date(maxDate)) : minDate;
  [minDate, maxDate] = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
  const rows = this.rows;
  for (let i = 0, k = rows.length; i < k; i++) {
    const row = rows[i];
    for (let j = 0, l = row.length; j < l; j++) {
      if (this.showWeekNumber && j === 0) continue;
      const cell = row[j];
      const year = this.date.getFullYear();
      // 区分 半年&&季度 和 旬 时间戳取值
      const month = interval === 10 ? this.date.getMonth() : j * interval;
      const day = interval === 10 ? j * interval + 1 : 1;
      const time = timeForYMDDate(new Date(year, month, day));
      cell.inRange = minDate && time >= minDate && time <= maxDate;
      cell.start = minDate && time === minDate;
      cell.end = maxDate && time === maxDate;
    }
  }
  this.$forceUpdate();
};
const handleRows = function (interval, number) {
  const rows = [[]]; // 只渲染一列
  const disabledDate = this.disabledDate;
  const selectedDate = [];
  const now = timeForYMDDate(new Date());

  const row = rows[0];
  for (let j = 0; j < number; j++) {
    let cell = row[j];
    if (!cell) {
      cell = {
        row: 0,
        column: j,
        type: "normal",
        inRange: false,
        start: false,
        end: false,
      };
    }

    cell.type = "normal";

    const index = j * interval;
    const time = new Date(this.date.getFullYear(), index, 1).getTime();
    cell.inRange =
      time >= timeForYMDDate(new Date(this.minDate)) &&
      time <= timeForYMDDate(new Date(this.maxDate));
    cell.start =
      this.minDate && time === timeForYMDDate(new Date(this.minDate));
    cell.end = this.maxDate && time === timeForYMDDate(new Date(this.maxDate));
    const isToday = time === now;

    if (isToday) {
      cell.type = "today";
    }
    cell.text = j;
    let cellDate = new Date(time);
    cell.disabled =
      typeof disabledDate === "function" && disabledDate(cellDate);
    cell.selected = arrayFind(
      selectedDate,
      (date) => date.getTime() === cellDate.getTime()
    );
    this.$set(row, j, cell);
  }
  return rows;
};

const now = new Date();
const nowYear = now.getFullYear(),
  nowQuarter = Math.ceil((now.getMonth() + 1) / 3),
  nowHalfYear = Math.ceil((now.getMonth() + 1) / 6),
  nowMonth = now.getMonth(),
  nowMeadow = now.getDate();

export function createDatePicker(DatePicker) {
  let displayValue = DatePicker.mixins[0].computed.displayValue;
  return {
    name: DatePicker.name,
    props: {
      periodType: String,
    },
    extends: DatePicker,
    created() {
      this.getPanel();
    },
    computed: {
      displayValue() {
        let dv = displayValue.call(this);
        let isRange = false;
        if (/range/.test(this.type)) {
          isRange = true;
        }
        if (!Array.isArray(dv)) {
          dv = [dv];
        }
        let value = dv;
        // 处理中文显示样式
        value = dv.map((d) => {
          if (!d) return "";
          let format = [];
          const times = d.split("-");
          if (this.$i18n.locale === "zh_CN") {
            if (this.periodType === "MD") {
              // 旬
              format = [times[0], times[1], valueMapping.meadow[times[2]]];
            } else if (this.periodType === "SS") {
              // 季度
              format = [times[0], valueMapping.quarter[times[1]]];
            } else {
              // 半年
              format = [times[0], valueMapping.halfYear[times[1]]];
            }
          } else {
            format = times;
          }

          return this.$t(`platform.datePicker.${this.periodType}Text`, format);
          // if (this.format === "yyyy年MM月dd旬") {
          //   return d?.replace(
          //     /(\d+)旬/,
          //     (v, g1) => `${valueMapping.meadow[g1]}旬`
          //   );
          // } else if (this.format === "yyyy年第M季度") {
          //   return d?.replace(
          //     /(\d+)季度/,
          //     (v, g1) => `${valueMapping.quarter[g1]}季度`
          //   );
          // } else {
          //   return d?.replace(
          //     /(\d+)半年/,
          //     (v, g1) => `${valueMapping.halfYear[g1]}半年`
          //   );
          // }
        });

        return isRange ? value : value[0];
      },
    },
    watch: {
      periodType: "updatePanel",
    },
    methods: {
      updatePanel() {
        let has = false;
        if (this.picker) {
          this.unmountPicker();
          this.picker = null;
          has = true;
        }
        DatePicker.watch.type.call(this, this.type);
        this.getPanel();
        if (has) {
          this.mountPicker();
        }
      },

      getPanel() {
        if (this.periodType == "MD") {
          createMeadowPanel.call(this);
        } else if (this.periodType == "SS") {
          createQuarterPanel.call(this);
        } else if (this.periodType == "HY") {
          createHalfYearPanel.call(this);
        }
      },
    },
  };
}
// 旬
function createMeadowPanel() {
  const DateTable = this.panel.components.DateTable;
  if (!DateTable?.computed) return;
  const render = DateTable.render;
  const MeadowTable = {
    extends: DateTable,
    // i18n: this.$parent.$root.$i18n, // 强制赋予根节点国际化对象
    computed: {
      rows() {
        let data = [];
        const maxDate = timeForYMDDate(new Date(this.maxDate));
        const minDate = timeForYMDDate(new Date(this.minDate));
        for (let i = 0; i < 3; i++) {
          const currentTime = new Date(
            this.year,
            this.month,
            i * 10 + 1
          ).getTime();
          const cellDate = new Date(currentTime);

          let cell = {
            disabled:
              typeof this.disabledDate === "function" &&
              this.disabledDate(cellDate),
            customClass:
              typeof this.cellClassName === "function" &&
              this.cellClassName(cellDate),
            text: this.translate(meadowTextMap[i]),
            type: this.isToday(i),
            inRange: this.inRange(currentTime, maxDate, minDate),
            start: minDate && currentTime === minDate,
            end: maxDate && currentTime === maxDate,
            selected: currentTime === minDate || currentTime === maxDate,
          };
          data.push(cell);
        }
        return [data];
      },
    },
    methods: {
      isToday(i) {
        const startDate = new Date(this.startDate);
        const sYM = [startDate.getFullYear(), startDate.getMonth() + 1];
        if (sYM[0] === nowYear && sYM[1] === nowMonth) {
          let j = -1;
          if (_.inRange(nowMeadow, 0, 11)) {
            j = 0;
          } else if (_.inRange(nowMeadow, 11, 21)) {
            j = 1;
          } else {
            j = 2;
          }
          return i === j ? "today" : "normal";
        } else {
          return "normal";
        }
      },
      inRange(cur, max, min) {
        return min && cur >= min && cur <= max;
      },
      getDateOfCell(e, t) {
        return new Date(this.year, this.month, t * 10 + 1);
      },
      handleClick(event) {
        let target = event.target;
        const nodeName = target.nodeName.toLowerCase();
        const clickIndex =
          nodeName === "td"
            ? target.cellIndex
            : $(target).parents("td")[0]?.cellIndex;
        if (!dsf.isNumber(clickIndex)) return;
        let index;
        if (clickIndex == 0) {
          index = 1;
        } else if (clickIndex == 1) {
          index = 11;
        } else {
          index = 21;
        }
        const newDate = new Date(this.year, this.month, index);
        if (this.selectionMode === "range") {
          if (!this.rangeState.selecting) {
            this.$emit("pick", { minDate: newDate, maxDate: null });
            this.rangeState.selecting = true;
          } else {
            if (newDate >= this.minDate) {
              this.$emit("pick", { minDate: this.minDate, maxDate: newDate });
            } else {
              this.$emit("pick", { minDate: newDate, maxDate: this.minDate });
            }
            this.rangeState.selecting = false;
          }
        } else {
          this.$emit("pick", newDate);
        }
      },
      markRange(minDate, maxDate) {
        markRange.call(this, minDate, maxDate, 10);
      },
      cellMatchesDate(cell, date) {
        const day = meadowTextMap.indexOf(cell.text);
        const value = new Date(date);
        return (
          this.year === value.getFullYear() &&
          this.month === value.getMonth() &&
          Number(day * 10 + 1) === value.getDate()
        );
      },
      translate(key) {
        return this.$t(`platform.datePicker.${key}`);
        // return meadowTextMap[key.split(".")[3]];
      },
    },
    render(h) {
      let vNodes = render.call(this, h);
      vNodes.children[0].children[0].children = [];
      vNodes.children[0].children[1].children.splice(3, 8);
      return vNodes;
    },
  };

  this.panel = {
    extends: this.panel,
    components: { DateTable: MeadowTable },
  };
}
// 季度
function createQuarterPanel() {
  const MonthTable = this.panel.components.MonthTable;
  if (!MonthTable?.computed) return;
  const getCellStyle = MonthTable.methods.getCellStyle;
  const QuarterTable = {
    extends: MonthTable,
    // i18n: this.$parent.$root.$i18n, // 强制赋予根节点国际化对象
    data() {
      return {
        months: [
          "firstQuarter",
          "secondQuarter",
          "thirdQuarter",
          "fourthQuarter",
        ],
      };
    },
    computed: {
      rows() {
        const rows = handleRows.call(this, 3, 4);
        return rows;
      },
    },
    methods: {
      getCellStyle(cell) {
        let style = getCellStyle.call(this, cell);
        const value = new Date(this.value);
        const [valueYear, valueMonth] = [value.getFullYear(), value.getMonth()];
        const currentYear = new Date(this.date).getFullYear();
        style.today =
          this.date.getFullYear() == nowYear && nowQuarter == cell.text + 1;
        style.current =
          valueYear === currentYear && valueMonth === cell.text * 3;
        return style;
      },
      markRange(minDate, maxDate) {
        markRange.call(this, minDate, maxDate, 3);
      },
      getMonthOfCell(month) {
        return getMonthOfCell.call(this, month, 3);
      },
      handleMonthTableClick(event) {
        handleMonthClick.call(this, event, 3);
      },
      t(key) {
        return this.$t(`platform.datePicker.${key.split(".")[3]}`);
      },
    },
  };
  this.panel = {
    extends: this.panel,
    components: { MonthTable: QuarterTable },
  };
}
// 半年
function createHalfYearPanel() {
  const MonthTable = this.panel.components.MonthTable;
  if (!MonthTable?.computed) return;
  const getCellStyle = MonthTable.methods.getCellStyle;
  const render = MonthTable.render;

  const HalfYearTable = {
    extends: MonthTable,
    // i18n: this.$parent.$root.$i18n, // 强制赋予根节点国际化对象
    computed: {
      rows() {
        return handleRows.call(this, 6, 2);
      },
    },
    data() {
      return {
        months: ["firstHalf", "secondHalf"],
      };
    },
    methods: {
      getCellStyle(cell) {
        let style = getCellStyle.call(this, cell);
        const value = new Date(this.value);
        const [valueYear, valueMonth] = [value.getFullYear(), value.getMonth()];
        const currentYear = new Date(this.date).getFullYear();
        style.today =
          this.date.getFullYear() == nowYear && nowHalfYear == cell.text + 1;
        style.current =
          valueYear === currentYear && valueMonth === cell.text * 6;
        return style;
      },
      markRange(minDate, maxDate) {
        markRange.call(this, minDate, maxDate, 6);
      },
      getMonthOfCell(month) {
        return getMonthOfCell.call(this, month, 6);
      },
      handleMonthTableClick(event) {
        handleMonthClick.call(this, event, 6);
      },
      t(key) {
        return this.$t(`platform.datePicker.${key.split(".")[3]}`);
      },
    },
    render(h) {
      let vNodes = render.call(this, h);
      vNodes.children[0].children[0].children.splice(2, 4);
      return vNodes;
    },
  };

  this.panel = {
    extends: this.panel,
    components: { MonthTable: HalfYearTable },
  };
}

export const isDate = function (date) {
  if (date === null || date === undefined) return false;
  if (isNaN(new Date(date).getTime())) return false;
  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
  return true;
};
